// ---
// 「ブランドから探す」セクションを非表示にする（articlesページのみ）- PC・スマホ対応
// ---
(function() {
  function hideBrandSectionForArticles() {
    // articlesページの場合のみ実行
    if (window.location.href.includes('/apps/staffstart')) {
      // PC版の構造 (.sc-YysOfクラス)
      document.querySelectorAll('.sc-YysOf').forEach((section) => {
        const heading = section.querySelector('.sc-gEvEer');
        if (heading && heading.textContent === 'ブランドから探す') {
          if (!section.dataset.articlesProcessed) {
            section.style.display = 'none';
            section.dataset.articlesProcessed = "true";
          }
        }
      });

      // スマホ版の構造 (.sc-EgOXTクラス)
      document.querySelectorAll('.sc-EgOXT').forEach((section) => {
        const heading = section.querySelector('.sc-gEvEer');
        if (heading && heading.textContent === 'ブランドから探す') {
          if (!section.dataset.articlesProcessed) {
            section.style.display = 'none';
            section.dataset.articlesProcessed = "true";
          }
        }
      });
    }
  }

  // DOMContentLoaded前でも実行
  hideBrandSectionForArticles();

  // DOMContentLoaded後にも実行
  document.addEventListener("DOMContentLoaded", function() {
    hideBrandSectionForArticles();

    new MutationObserver(hideBrandSectionForArticles).observe(document.body, {
      childList: true,
      subtree: true
    });

    const interval = setInterval(hideBrandSectionForArticles, 500);
    setTimeout(() => clearInterval(interval), 10000);
  });
})();

// ---
// 「ブランドから探す」で表示させる項目の制御（articlesページ以外）- PC・スマホ対応
// ---
(function() {
  // 表示するブランドのリスト
  const brandsToShow = [
    "Alpha Industries"
  ];

  function hideNonSelectedBrands() {
    // articlesページの場合はスキップ
    if (window.location.href.includes('/apps/staffstart/articles')) {
      return;
    }

    // PC版の構造処理
    const brandHeadings = Array.from(document.querySelectorAll(".sc-cVzyXs, .sc-jArIUG")).filter(heading => {
      const pElement = heading.querySelector('.sc-gEvEer');
      return pElement && pElement.textContent.trim() === "ブランドから探す";
    });

    for (const brandHeading of brandHeadings) {
      const brandSection = brandHeading.closest('.sc-YysOf, .sc-jhgNWf');

      if (!brandSection) continue;

      const brandList = brandSection.querySelector('.sc-ePDLzJ');

      if (brandList && brandList.dataset.processed !== "true") {
        const listItems = brandList.querySelectorAll('.sc-bVVIoq');

        listItems.forEach(item => {
          const link = item.querySelector('a');
          if (!link) return;

          const href = link.getAttribute('href');
          const text = link.textContent.trim();

          if (text === "すべて") return;

          const isSpecifiedBrand = brandsToShow.some(brand => {
            if (text === brand) return true;

            const encodedBrand = encodeURIComponent(brand).replace(/'/g, '%27');
            return href.includes(`productLabelCode=${encodedBrand}`) ||
                  href.includes(`label=${encodedBrand}`);
          });

          if (!isSpecifiedBrand) {
            item.style.display = 'none';
          }

          item.dataset.processed = "true";
        });

        brandList.dataset.processed = "true";
      }

      // PC版のセレクトボックス処理
      const selectBoxes = brandSection.querySelectorAll('select');

      selectBoxes.forEach(select => {
        if (select.dataset.processed === "true") return;

        const options = select.querySelectorAll('option');

        options.forEach(option => {
          const value = option.value;
          const text = option.textContent.trim();

          if (value === "" || text === "すべて" || text === "選択してください") return;

          if (!brandsToShow.includes(text)) {
            option.style.display = 'none';

            try {
              option.remove();
            } catch (e) {
            }
          }
        });

        select.dataset.processed = "true";
      });
    }

    // スマホ版の構造処理
    document.querySelectorAll('.sc-EgOXT').forEach((section) => {
      const heading = section.querySelector('.sc-gEvEer');
      if (heading && heading.textContent === 'ブランドから探す') {
        if (!section.dataset.brandProcessed) {
          const select = section.querySelector('select');
          if (select) {
            const options = select.querySelectorAll('option');

            options.forEach(option => {
              const value = option.value;
              const text = option.textContent.trim();

              if (value === "" || text === "すべて" || text === "選択してください") return;

              if (!brandsToShow.includes(text)) {
                try {
                  option.remove();
                } catch (e) {
                  option.style.display = 'none';
                }
              }
            });
          }
          section.dataset.brandProcessed = "true";
        }
      }
    });
  }

  // 即座に実行
  hideNonSelectedBrands();

  // 短い間隔で繰り返し実行（coordinatesページの動的読み込み対応）
  let attemptCount = 0;
  const quickInterval = setInterval(() => {
    hideNonSelectedBrands();
    attemptCount++;

    // 100回試行したら停止（約10秒）
    if (attemptCount >= 100) {
      clearInterval(quickInterval);
    }
  }, 100);

  // DOMContentLoaded後にも実行
  document.addEventListener("DOMContentLoaded", function() {
    hideNonSelectedBrands();

    const interval = setInterval(hideNonSelectedBrands, 1000);

    const observer = new MutationObserver(function(mutations) {
      hideNonSelectedBrands();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => clearInterval(interval), 10000);
  });
})();

// ---
// KIDSカテゴリーを非表示にする
// ---
document.addEventListener("DOMContentLoaded", function() {
  function hideKidsOption() {
    // タイプから探すのKIDSリンクを非表示
    document.querySelectorAll('a[href*="genre=3"]').forEach(link => {
      if (link.textContent.trim() === "KIDS" && !link.dataset.processed) {
        const listItem = link.closest('.sc-bVVIoq');
        if (listItem) {
          listItem.style.display = 'none';
          listItem.dataset.processed = "true";
        }
        link.dataset.processed = "true";
      }
    });

    // セレクトボックスのKIDSオプション（option[value="3"]）を非表示
    document.querySelectorAll('select option[value="3"]').forEach(option => {
      if (!option.dataset.processed) {
        try {
          option.remove();
        } catch (e) {
          option.style.display = 'none';
          option.disabled = true;
        }
        option.dataset.processed = "true";
      }
    });
  }

  hideKidsOption();

  new MutationObserver(hideKidsOption).observe(document.body, {
    childList: true,
    subtree: true
  });

  const interval = setInterval(hideKidsOption, 1000);
  setTimeout(() => clearInterval(interval), 10000);
});

// ---
// 店舗から探すについてはデフォルト非表示にしURLパラメーターに?label=もしくは&staffLabelId= が使われている場合のみ表示する
// ---
document.addEventListener("DOMContentLoaded", function() {
  let currentUrlParams = new URLSearchParams(window.location.search);
  // let shouldShowStores = currentUrlParams.has('label') || currentUrlParams.has('staffLabelId');
  let shouldShowStores =
  window.location.pathname.includes('/apps/staffstart/coordinates') ||
  currentUrlParams.has('label') || currentUrlParams.has('staffLabelId');

  function checkUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    // const newShouldShow = urlParams.has('label') || urlParams.has('staffLabelId');
    const newShouldShow =
  window.location.pathname.includes('/apps/staffstart/coordinates') ||
  (urlParams.has('label') || urlParams.has('staffLabelId'));

    if (newShouldShow !== shouldShowStores) {
      shouldShowStores = newShouldShow;
      currentUrlParams = urlParams;
      handleStoreSection(true);
    }
  }

  function handleStoreSection(forceUpdate = false) {
    // PC版 - 新しいクラス名で店舗から探すセクションを検索
    document.querySelectorAll('.sc-YysOf').forEach((section) => {
      const heading = section.querySelector('.sc-gEvEer');
      if (heading && heading.textContent === '店舗から探す') {
        if (!section.dataset.storeProcessed || forceUpdate) {
          section.style.display = shouldShowStores ? 'block' : 'none';
          section.dataset.storeProcessed = "true";
        }
      }
    });

    // スマホ版 - 店舗から探すセクションの処理
    document.querySelectorAll('.sc-EgOXT').forEach((section) => {
      const heading = section.querySelector('.sc-gEvEer');
      if (heading && heading.textContent === '店舗から探す') {
        if (!section.dataset.storeProcessed || forceUpdate) {
          section.style.display = shouldShowStores ? 'flex' : 'none';
          section.dataset.storeProcessed = "true";
        }
      }
    });
  }

  handleStoreSection();

  const observer = new MutationObserver(() => {
    handleStoreSection();
    checkUrlParams();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function() {
    originalPushState.apply(this, arguments);
    checkUrlParams();
  };

  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    checkUrlParams();
  };

  window.addEventListener('popstate', checkUrlParams);

  const intervalDom = setInterval(handleStoreSection, 1000);
  const intervalUrl = setInterval(checkUrlParams, 1000);

  setTimeout(() => {
    clearInterval(intervalDom);
    clearInterval(intervalUrl);
    handleStoreSection();
    checkUrlParams();
  }, 10000);
});

// ---
// 「所属ブランドから探す」で表示させる項目の制御 - PC・スマホ対応
// ---
document.addEventListener("DOMContentLoaded", function () {
    function getBrandsToShowBasedOnURL() {
      const currentURL = window.location.href;
      if (currentURL.includes('/apps/staffstart/articles')) {
        return [
          "AVIREX", "AVIREX DEPOT", "B'2nd", "B'2nd OUTLET", "BEAVER",
          "GARDEN", "LHP", "MANASTASH", "ROYAL FLASH", "Schott","PINKY & DIANNE"
        ];
      } else if (currentURL.includes('/apps/staffstart/staffs')) {
        return [
          "ADORE",
          "AVIREX",
          "B'2nd",
          "BEAVER",
          "FREE'S MART",
          "GARDEN",
          "hLM",
          "human woman",
          "Jack Bunny!!",
          "JILL by JILL STUART",
          "LE PHIL",
          "LHP",
          "MANASTASH",
          "MASTER BUNNY EDITION",
          "N. Natural Beauty Basic*",
          "NANO universe",
          "NATURAL BEAUTY BASIC",
          "New Balance Golf",
          "PINKY & DIANNE",
          "PROPORTION BODY DRESSING",
          "ROYAL FLASH",
          "SCHOTT",
          "St ANDREWS",
          "hueLe Museum",
          "PEARLY GATES",
          "THE LIBRARY",
          "PROPORTION",
          "YLÈVE",
          "MHL."
        ];
      } else {
        return [
          "AVIREX", "AVIREX DEPOT", "B'2nd", "B'2nd OUTLET", "BEAVER",
          "GARDEN", "LHP", "MANASTASH", "ROYAL FLASH", "Schott"
        ];
      }
    }


  function hideNonSelectedBrands() {
    const brandsToShow = getBrandsToShowBasedOnURL();

    // PC版の構造処理
    const brandHeadings = Array.from(document.querySelectorAll(".sc-cVzyXs, .sc-jArIUG")).filter(heading => {
      const pElement = heading.querySelector('.sc-gEvEer');
      return pElement && pElement.textContent.trim() === "所属ブランドから探す";
    });

    for (const brandHeading of brandHeadings) {
      const brandSection = brandHeading.closest('.sc-YysOf, .sc-jhgNWf');

      if (!brandSection) continue;

      const brandList = brandSection.querySelector('.sc-ePDLzJ');

      if (brandList) {
        const listItems = brandList.querySelectorAll('.sc-bVVIoq');
        let allItemsProcessed = true;

        listItems.forEach(item => {
          if (item.dataset.processed !== "true") {
            allItemsProcessed = false;
            const link = item.querySelector('a');
            if (!link) return;

            const href = link.getAttribute('href');
            const text = link.textContent.trim();

            if (text === "すべて") return;

            const isSpecifiedBrand = brandsToShow.some(brand => {
              return text.toLowerCase() === brand.toLowerCase();
            });

            if (!isSpecifiedBrand) {
              item.style.display = 'none';
            }

            item.dataset.processed = "true";
          }
        });

        if (allItemsProcessed) {
          brandList.dataset.processed = "true";
        }
      }

      const selectBoxes = brandSection.querySelectorAll('select');

      selectBoxes.forEach(select => {
        if (select.dataset.processed === "true") return;

        const options = select.querySelectorAll('option');
        let allOptionsProcessed = true;

        options.forEach(option => {
          if (option.dataset.processed !== "true") {
            allOptionsProcessed = false;
            const value = option.value;
            const text = option.textContent.trim();

            if (value === "" || text === "すべて" || text === "選択してください") return;

            const isSpecifiedBrand = brandsToShow.some(brand => {
              return text.toLowerCase() === brand.toLowerCase();
            });

            if (!isSpecifiedBrand) {
              option.style.display = 'none';

              try {
                option.remove();
              } catch (e) {
              }
            }

            option.dataset.processed = "true";
          }
        });

        if (allOptionsProcessed) {
          select.dataset.processed = "true";
        }
      });
    }

    // スマホ版の構造処理
    document.querySelectorAll('.sc-EgOXT').forEach((section) => {
      const heading = section.querySelector('.sc-gEvEer');
      if (heading && heading.textContent === '所属ブランドから探す') {
        if (!section.dataset.staffProcessed) {
          const select = section.querySelector('select');
          if (select) {
            const options = select.querySelectorAll('option');

            options.forEach(option => {
              const value = option.value;
              const text = option.textContent.trim();

              if (value === "" || text === "すべて" || text === "選択してください") return;

              // ブランド名のマッピング処理（スマホ版では表記が異なる場合がある）
              const isSpecifiedBrand = brandsToShow.some(brand => {
                // 完全一致
                if (text.toLowerCase() === brand.toLowerCase()) return true;

                // 特別なマッピング
                if (text === "nano・universe" && brand === "NANO universe") return true;
                if (text === "PINKY & DIANNE" && brand === "PINKY & DIANNE") return true;
                if (text === "hueLe Museum" && brand === "hueLe Museum") return true;
                if (text === "PROPORTION" && brand === "PROPORTION BODY DRESSING") return true;
                if (text === "Schott" && brand === "Schott") return true;

                return false;
              });

              if (!isSpecifiedBrand) {
                option.style.display = 'none';

                try {
                  option.remove();
                } catch (e) {
                }
              }
            });
          }
          section.dataset.staffProcessed = "true";
        }
      }
    });
  }

  hideNonSelectedBrands();

  const interval = setInterval(hideNonSelectedBrands, 1000);

  const observer = new MutationObserver(function(mutations) {
    hideNonSelectedBrands();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(() => clearInterval(interval), 10000);
});
